import axios from 'axios';

// Session läuft über httpOnly-Cookie (withCredentials) — kein Token mehr im localStorage
const api = axios.create({
  baseURL: 'https://letscareers.de/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      // Session abgelaufen/ungültig → AppContext räumt den User-State auf
      window.dispatchEvent(new Event('auth:expired'));
    }
    return Promise.reject(err);
  }
);

// Auth
export const authRegister = (data) => api.post('/auth/register', data);
export const authLogin = (data) => api.post('/auth/login', data);
export const authVerify2FA = (email, code) => api.post('/auth/verify-2fa', { email, code });
export const authLogout = () => api.post('/auth/logout');
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });
export const resendVerification = (email) => api.post('/auth/resend-verification', { email });
export const verifyEmailCode = (email, code) => api.post('/auth/verify-email-code', { email, code });

// Jobs
const serializeParams = (params) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (Array.isArray(val)) val.forEach(v => sp.append(key, v));
    else if (val !== undefined && val !== null && val !== '') sp.append(key, val);
  });
  return sp.toString();
};
export const fetchJobs = (params) => api.get('/jobs', { params, paramsSerializer: { serialize: serializeParams } });
export const fetchJob = (id) => api.get(`/jobs/${id}`);
export const createJob = (data) => api.post('/jobs', data);
export const updateJob = (id, data) => api.patch(`/jobs/${id}`, data);
export const fetchSavedJobs = () => api.get('/jobs/saved');
// Auswahllisten (Slugs) für Inserat-Formular und Filter
export const fetchJobOptions = () => api.get('/jobs/options');
// Trefferzahl je Branche unter den aktuell gesetzten Filtern
export const fetchFilterCounts = (params) =>
  api.get('/jobs/filter-counts', { params, paramsSerializer: { serialize: serializeParams } });

// Orte (Autocomplete)
export const searchLocations = (q, limit = 8) =>
  api.get('/locations/search', { params: { q, limit } });

// Applications
export const postApplication = (jobId) => api.post('/applications', { job_id: jobId });
export const fetchMyApplications = () => api.get('/applications/mine');
export const fetchJobApplications = (jobId) => api.get(`/applications/job/${jobId}`);
export const updateApplicationStatus = (id, status, notes) =>
  api.patch(`/applications/${id}/status`, { status, ...(notes ? { employer_notes: notes } : {}) });

// My jobs (employer)
export const fetchMyJobs = () => api.get('/jobs/mine');

// Saved jobs
export const postSaveJob = (jobId) => api.post(`/jobs/${jobId}/save`);
export const deleteSaveJob = (jobId) => api.delete(`/jobs/${jobId}/save`);

// Chat
export const fetchConversations = () => api.get('/chat/conversations');
export const createConversation = (applicationId) =>
  api.post('/chat/conversations', { application_id: applicationId });

// Profile
export const fetchProfile = () => api.get('/profile');
export const updateProfile = (data) => api.put('/profile', data);
export const uploadAvatar = (base64) => api.put('/profile/avatar', { avatar: base64 });
export const deleteAccount = () => api.delete('/profile');

export default api;
